__turbopack_context__.v({
  "navLink": "YBaM2q_navLink",
});
